import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=5551504c&scoped=true"
import script from "./overview.vue?vue&type=script&setup=true&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=5551504c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5551504c",
  null
  
)

export default component.exports